import { render } from "./ManageCookie.vue?vue&type=template&id=bf7f3808"
import script from "./ManageCookie.vue?vue&type=script&lang=js"
export * from "./ManageCookie.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__